import { AlertTriangle } from "lucide-react";
import type { CenteredNoticeProps } from "./types";

export const CenteredNotice = ({ message }: CenteredNoticeProps) => (
  <div className="flex flex-1 items-center justify-center">
    <div className="flex items-center gap-2 rounded-lg bg-amber-50 px-4 py-3 text-sm text-amber-800">
      <AlertTriangle size={18} className="shrink-0 text-amber-600" />
      {message}
    </div>
  </div>
);
